import { render, staticRenderFns } from "./serviceResult.vue?vue&type=template&id=1e3116c4&scoped=true"
import script from "./serviceResult.vue?vue&type=script&lang=js"
export * from "./serviceResult.vue?vue&type=script&lang=js"
import style0 from "./serviceResult.vue?vue&type=style&index=0&id=1e3116c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3116c4",
  null
  
)

export default component.exports